import Country from "../model/Country";
import { addPresentation } from "./presentation";

export default addPresentation(Country, {
  canAdd: true,
  canEdit: true,
  canRemove: false,
  columns: ["Code", "Name"],
});
